import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import type { SubscriptionOffersDto } from "$src/core/models/dto";

export const queryKey = () => ["subscription-offers"];

const useSubscriptionOffersQuery = (
  options?: Omit<
    UseQueryOptions<Awaited<SubscriptionOffersDto>>,
    "queryKey" | "queryFn"
  >,
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(),
    queryFn: () => api.getSubscriptionOffers(),
    ...options,
  });
};

export default useSubscriptionOffersQuery;
